<div class="bg-white rounded-lg shadow-sm p-6 border border-gray-200 h-full">
  <div class="flex items-center mb-5">
    <div
      class="w-5 h-5 rounded-full mr-4 relative"
      [ngClass]="hasActiveGST ? 'bg-green-500' : 'bg-red-500'"
    >
      <div
        class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-2 h-2 bg-white rounded-full"
      ></div>
    </div>
    <h2 class="text-xl font-poppins font-semibold text-[#E53935] mb-0">GST Compliance</h2>
  </div>

  <div class="space-y-3">
    <div class="flex flex-col justify-start items-start border-b border-gray-100">
      <span class="font-poppins font-semibold text-[#4B4B4B]">Active GSTINs</span>
      <span class="font-poppins text-[#0E1116]">{{ activeGSTINsString }}</span>
    </div>

    <div class="flex justify-between items-center py-3 border-b border-gray-100">
      <span class="font-poppins font-medium text-[#4B4B4B]">Inactive GSTINs</span>
      <span class="font-poppins text-[#0E1116]">{{ inactiveGSTINsString }}</span>
    </div>

    <div class="flex justify-between items-center py-3 border-b border-gray-100">
      <span class="font-poppins font-medium text-[#4B4B4B]">Multi-State Operations</span>
      <span
        class="px-3 py-1 rounded-full text-xs font-poppins font-semibold"
        [ngClass]="hasActiveGST ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'"
      >
        {{ hasActiveGST ? 'VERIFIED' : 'NOT VERIFIED' }}
      </span>
    </div>

    <div class="text-center text-2xl font-poppins font-semibold text-orange-500 my-4">
      Total Returns Filed: {{ totalFilings }}
    </div>

    <div class="grid grid-cols-2 gap-3">
      <div class="text-center p-4 bg-green-100 rounded-lg text-green-800">
        <div class="text-2xl font-poppins font-semibold">{{ onTimeFilings }}</div>
        <div class="text-sm font-poppins">On Time Filings</div>
      </div>
      <div class="text-center p-4 bg-red-100 rounded-lg text-red-800">
        <div class="text-2xl font-poppins font-semibold">{{ delayedFilings }}</div>
        <div class="text-sm font-poppins">Delayed Filings</div>
      </div>
    </div>

    <div class="flex justify-between items-center py-3">
      <span class="font-poppins font-medium text-[#4B4B4B]">Overall Filing Status</span>
      <span
        class="px-3 py-1 rounded-full text-xs font-poppins font-semibold"
        [ngClass]="overallFilingStatus.className"
      >
        {{ overallFilingStatus.text }}
      </span>
    </div>
  </div>
</div>
